import { styled, css } from 'styled-components'

import colors from '@web-ui-kit/colors'
import SPACES from '@web-ui-kit/spaces'
import Text from '@web-ui-kit/text'
import TopNavExtended from '@web-ui-kit/topnav-extended'
import Select from '@web-ui-kit/select'
import { getDevices } from '@web-ui-kit/hooks.use-media-query'
import BasicButton from '@web-ui-kit/basic-button'
import { DEVICE_SIZE, fadeIn } from 'utils/constants'

const { SMALL } = getDevices()

export const StyledTopNavExtended = styled(TopNavExtended)`
  && {
    padding: 0 ${SPACES.M};
    position: sticky;
    z-index: 4;
  }
  ${({ $isSmall }) =>
    $isSmall &&
    css`
      && {
        min-height: 4.5rem;
        overflow: hidden;
        padding: 0;
      }
      & > div {
        padding: 0 ${SPACES.S};
      }
      nav {
        max-width: 100vw;
        padding-left: ${SPACES.M};
      }
    `}
`

export const Container = styled.header`
  background-color: ${colors.WHITE};
  box-sizing: border-box;
  grid-area: header;
  max-height: 7.3175rem;
  padding: 0 ${SPACES.S};
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 1;
  ::before {
    background-color: ${colors.NEUTRAL_200};
    bottom: 0;
    content: '';
    display: block;
    height: 0.125rem;
    left: 0;
    position: absolute;
    right: 0;
    width: 100%;
  }
`

export const MainBar = styled.div`
  align-items: center;
  display: flex;
  height: 4.0625rem;
  justify-content: space-between;
  @media (hover: hover) {
    & button:hover {
      border-color: transparent;
    }
  }
`

export const LeftSide = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: inherit;
  line-height: initial;
  gap: ${SPACES.S};
  margin-left: ${SPACES.S};

  > span {
    margin: 0 1rem;
  }
`

export const LeftSideSelectedOption = styled.div`
  align-items: center;
  animation: ${fadeIn} 0.5s ease;
  display: inherit;
  pointer-events: none;
  @media (max-width: ${DEVICE_SIZE.TABLET_S}) {
    display: none;
  }
`

export const Divider = styled.div`
  border-left: 0.0625rem solid ${colors.NEUTRAL_400};
  height: ${SPACES.L};
  margin-right: 1rem;
`

export const CourseName = styled(Text)`
  color: ${({ theme }) => theme?.colors?.ACCENT_700};
`

export const Title = styled(Text)`
  border-left: 0;
  display: block;
  margin-right: ${SPACES.S};
  max-width: 43.75rem;
  min-width: ${({ $isSmall, $isTablet }) =>
    $isSmall || $isTablet ? '0' : 'auto'};
  overflow: hidden;
  padding-left: 1.3rem;
  text-overflow: ellipsis;
  text-transform: initial;
  white-space: nowrap;
  width: 100%;
  -webkit-line-clamp: 1;
  && {
    display: block;
    line-height: 140%;
    padding-right: 0.1rem;
  }

  ${({ $isDemo, $isLaptop }) =>
    $isLaptop &&
    css`
      max-width: ${$isDemo ? '23.8rem' : '31rem'};
    `}
  ${({ $isDemo, $isTablet }) =>
    $isTablet &&
    css`
      max-width: ${$isDemo ? '18.25rem' : '20.25rem'};
    `}
  ${({ $isDemo, $isSmall }) =>
    $isSmall &&
    css`
      max-width: ${$isDemo ? '13.75rem' : '16rem'};
    `}
`

export const DropDownContainer = styled.nav`
  max-height: ${({ $open }) => ($open ? '3.25rem' : 0)};
  transition: max-height 0.3s ease, opacity 1s ease;
  overflow: ${({ $open }) => ($open ? 'visible' : 'hidden')};
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  button {
    @media (max-width: ${DEVICE_SIZE.TABLET}) {
      padding: 0 0.8rem;
    }
  }
`

export const DropDownList = styled.ul`
  align-items: center;
  display: flex;
  height: 2.75rem;
  margin-top: 0.5rem;
`
export const DropDownItem = styled.li`
  align-items: inherit;
  display: inherit;
  height: inherit;
  margin-top: 0.375rem;
  padding: 0 1rem;
  white-space: nowrap;

  @media (max-width: ${DEVICE_SIZE.TABLET}) {
    padding: 0 0.2rem;
    & a {
      font-size: 0.9rem;
      padding: 0.5rem;
    }
  }

  @media (max-width: ${DEVICE_SIZE.MOBILE_L}) {
    padding: 0 0.7rem;
  }
`

export const StyledSelect = styled(Select)`
  width: 100%;
  @media (${SMALL}) {
    max-width: 13.75rem;
  }
`

export const StyledButton = styled(BasicButton)`
  && {
    width: 100%;
    @media (${SMALL}) {
      width: fit-content;
    }
  }
`

export const StyledActionsContainer = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${SPACES.M};
  padding: 0 ${SPACES.M};
  width: 100%;
  @media (${SMALL}) {
    flex-direction: row;
    gap: ${SPACES.S};
    justify-content: flex-end;
    padding: 0;
  }
`
